import React, { useEffect, useState } from 'react';
import { formatMoneyPlain, parseMoneyInput } from '../../utils/formatMoney';

type MoneyInputProps = {
  value: number;
  onChange: (value: number) => void;
  className?: string;
  title?: string;
  emptyIfZero?: boolean;
};

const MoneyInput: React.FC<MoneyInputProps> = ({
  value,
  onChange,
  className = '',
  title,
  emptyIfZero = false,
}) => {
  const [focused, setFocused] = useState(false);
  const [draft, setDraft] = useState('');
  const display = emptyIfZero && (!value || value === 0) ? '' : formatMoneyPlain(value || 0);

  useEffect(() => {
    if (!focused) setDraft(display);
  }, [display, focused]);

  return (
    <input
      type="text"
      inputMode="decimal"
      dir="ltr"
      className={className}
      title={title}
      value={focused ? draft : display}
      onFocus={(event) => {
        setFocused(true);
        setDraft(display);
        event.target.select();
      }}
      onChange={(event) => setDraft(event.target.value)}
      onBlur={() => {
        setFocused(false);
        if (!draft.trim()) {
          onChange(0);
          return;
        }
        onChange(parseMoneyInput(draft));
      }}
    />
  );
};

export default MoneyInput;
